import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  TransactionListQuery,
  TransactionRepository,
} from '@app/domain/ports/tpv/transaction.repository';
import { TpvTransaction } from '@app/domain/models/tpv/transaction.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/** Mock de transacciones para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class TransactionMockDataSource extends TransactionRepository {
  override getTransactions(
    externalIdMerchant?: string,
    query: TransactionListQuery = {},
  ): Observable<TpvPage<TpvTransaction>> {
    // En modo "todos" (sin comercio) se usa un id de ejemplo para el mock.
    const merchantId = externalIdMerchant ?? 'mock-merchant-all';
    const transactions: TpvTransaction[] = [
      {
        idTransaction: 'mock-txn-1',
        status: 'approved',
        createdAt: '2026-06-01T10:15:00Z',
        idTerminal: 'mock-terminal-1',
        externalIdMerchant: merchantId,
        merchantName: 'Comercio Demo 1',
        processor: 'Processor Demo',
        type: 'sale',
        paymentGateway: 'gateway-demo',
        paymentMethod: 'credit_card',
        email: 'cliente1@demo.com',
        grossAmount: 1000,
        tip: 50,
        commissionFee: 2.5,
        commissionAmount: 25,
        iva: 16,
        ivaAmount: 4,
        quotas: 1,
        receivedMerchantAmount: 971,
      },
      {
        idTransaction: 'mock-txn-2',
        status: 'declined',
        createdAt: '2026-06-02T14:30:00Z',
        idTerminal: 'mock-terminal-2',
        externalIdMerchant: merchantId,
        merchantName: 'Comercio Demo 1',
        processor: 'Processor Demo',
        type: 'sale',
        paymentGateway: 'gateway-demo',
        paymentMethod: 'debit_card',
        email: 'cliente2@demo.com',
        grossAmount: 500,
        tip: 0,
        commissionFee: 2.5,
        commissionAmount: 12.5,
        iva: 16,
        ivaAmount: 2,
        quotas: 1,
        receivedMerchantAmount: 485.5,
      },
      {
        idTransaction: 'mock-txn-3',
        status: 'approved',
        createdAt: '2026-06-03T09:00:00Z',
        idTerminal: 'mock-terminal-1',
        externalIdMerchant: merchantId,
        merchantName: 'Comercio Demo 1',
        processor: 'Processor Demo',
        type: 'refund',
        paymentGateway: 'gateway-demo',
        paymentMethod: 'credit_card',
        email: 'cliente3@demo.com',
        grossAmount: 250,
        tip: 0,
        commissionFee: 2.5,
        commissionAmount: 6.25,
        iva: 16,
        ivaAmount: 1,
        quotas: 3,
        receivedMerchantAmount: 242.75,
      },
    ];

    return of({
      data: transactions,
      total: transactions.length,
      page: query.page ?? 1,
      limit: query.limit ?? 10,
    }).pipe(delay(300));
  }
}
